/**
 * BlockedScreen — shown when a user's account has been suspended.
 * Replaces the entire app for blocked users.
 */
import { useAuthStore } from '@/stores/auth.store';
import UsersAPI from '@/api/users.api';
import styles from './BlockedScreen.module.css';

export default function BlockedScreen() {
  const { user, clearUser } = useAuthStore();

  async function handleLogout() {
    UsersAPI.logout();
    clearUser();
  }

  const displayName = user?.firstName
    ? user.firstName
    : user?.name ?? user?.email ?? '';

  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
        {/* Icon */}
        <div className={styles.iconWrap}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/>
          </svg>
        </div>

        {/* Title */}
        <h1 className={styles.title}>Аккаунт заблокирован</h1>

        {/* Message */}
        <p className={styles.message}>
          {displayName ? `${displayName}, доступ ` : 'Доступ '}
          к вашему аккаунту временно ограничен администратором платформы.
        </p>

        <div className={styles.infoBox}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className={styles.infoIcon}>
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="12"/>
            <line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
          <p className={styles.infoText}>
            Если вы считаете, что это произошло по ошибке, пожалуйста, свяжитесь с нашей службой поддержки.
            Мы рассмотрим ваше обращение и восстановим доступ в кратчайшие сроки.
          </p>
        </div>

        {/* Support contacts */}
        <div className={styles.contacts}>
          <a
            href="mailto:support@englishpatient.ru"
            className={styles.contactItem}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
              <polyline points="22,6 12,13 2,6"/>
            </svg>
            <span>support@englishpatient.ru</span>
          </a>
          <a
            href="https://t.me/englishpatient_support"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.contactItem}
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.96 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
            </svg>
            <span>Telegram поддержка</span>
          </a>
        </div>

        <button className={styles.logoutBtn} onClick={handleLogout}>
          Выйти из аккаунта
        </button>

        <p className={styles.email}>
          Текущий аккаунт: <strong>{user?.email}</strong>
        </p>
      </div>
    </div>
  );
}
